import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error('GlobalErrorHandler =>', error);

    const message = error?.message || error?.toString?.() || '';

    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      message.includes('Loading chunk') ||
      message.includes('Failed to fetch dynamically imported module');

    if (isChunkError) {
      const alreadyReloaded = sessionStorage.getItem('chunk-reload');

      if (!alreadyReloaded) {
        sessionStorage.setItem('chunk-reload', 'true');

        window.location.reload();

        return;
      }
    }
  }
}
